<template>
  <div class="sub-form-relation">
    <p class="sub-form-relation__title">Relate to</p>

    <BaseRadioBox
      name="relation"
      optionValue="product"
      v-model="form.relateTo"
    >Product</BaseRadioBox>

    <BaseRadioBox
      name="relation"
      optionValue="variant"
      v-model="form.relateTo"
    >Variant</BaseRadioBox>

    <BaseRadioBox
      name="relation"
      optionValue="collection"
      v-model="form.relateTo"
    >Collection</BaseRadioBox>

    <BaseRadioBox
      name="relation"
      optionValue="smart-collection"
      v-model="form.relateTo"
    >Smart collection</BaseRadioBox>

    <BaseRadioBox
      name="relation"
      optionValue="page"
      v-model="form.relateTo"
    >Page</BaseRadioBox>
    
    <BaseRadioBox
      name="relation"
      optionValue="blog"
      v-model="form.relateTo"
    >Blog</BaseRadioBox>
    
    <BaseRadioBox
      name="relation"
      optionValue="blog-post"
      v-model="form.relateTo"
    >Blog post</BaseRadioBox>
    
    <!-- <BaseRadioBox
      name="relation"
      optionValue="link-list"
      v-model="form.relateTo"
    >Link list</BaseRadioBox> -->
    
  </div>
</template>

<script>
  import subformMixin from '@/mixins/sub-form.mixin'

  export default {
    mixins: [ subformMixin ],
    data () {
      return {
        form: {
          relateTo: 'product'
        }
      }
    }
  }
</script>

<style lang="scss">
  .sub-form-relation {
    font-size: 14.6px;
    line-height: 1.43;
    
    &__title {
      margin-bottom: 2px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/forms/sub-forms/SubFormRelation.vue